export type IntegrationSectionKey = "api" | "fbcapi" | "webhooks" | "terminals";

export type IntegrationFeatureState = {
  hasFacebookConversionApi: boolean;
  hasLuda: boolean;
  hasOutboundWebhooks: boolean;
  hasPaymentTerminals: boolean;
  isInternalAdmin: boolean;
  isAccountAdmin: boolean;
};

export type IntegrationAccess = {
  canAccess: Record<IntegrationSectionKey, boolean>;
  hasAnyIntegration: boolean;
};

/**
 * Decides which integration sections a client may open. There is no
 * `integrations` gate of its own — the page exists exactly when one of the
 * sections below does.
 */
export function resolveIntegrationAccess(
  state: IntegrationFeatureState,
): IntegrationAccess {
  const canAccess: Record<IntegrationSectionKey, boolean> = {
    // The only scopes a key can carry come from `luda` or the internal admin
    // role, so without either there is nothing an API key could be used for.
    api: state.hasLuda || state.isInternalAdmin,
    // Mirrors the account-admin gate on the server's Conversion API routes.
    fbcapi: state.hasFacebookConversionApi && state.isAccountAdmin,
    webhooks: state.hasOutboundWebhooks,
    terminals: state.hasPaymentTerminals,
  };

  return {
    canAccess,
    hasAnyIntegration: Object.values(canAccess).some(Boolean),
  };
}
